// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__2ZZ0w","logoWrapper":"Header_logoWrapper__1yDr-"};